export const loportalRoutesConfig = [
  // TEMPALTE
  {
    method: "GET",
    path: "/loportal/user_pipeline",
    title: "Fetch User Pipeline",
    description: "Returns an array of loans",
    purpose: [
      `Retrieves the loan pipeline for a specific user. If user role is admin, all loans are returned.`,
      "- loanDocuments is left as an empty array for all returned loans. Not sure if this is intentional for optimization purposes or not.",
    ],
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: [
      {
        _id: "68ed0edd4e79a360968bf77d",
        createDateTime: "2025-10-13T14:38:21.887000",
        updateDateTime: "2025-10-13T14:38:21.887000",
        lastViewDateTime: "2025-10-13T14:38:21.887000",
        pipeline: "Underwriting",
        loanNumber: 1218,
        assetId: null,
        loanName: "116 Orange Avenue, Winter Haven, FL 33880",
        isTableFunding: false,
        isBalanceSheetClosing: false,
        loanStatus: "Prospect",
        milestoneStatusChanges: null,
        loanProductType: "DSCR",
        loanPurpose: "Refinance - Cash Out",
        purchaseTOE: null,
        exitStrategy: null,
        salesperson: "shaun@resilender.com",
        processor: null,
        underwriter: null,
        loanCloser: null,
        permittedUsers: [],
        baseLoanAmount: 140000,
        totalHoldback: 0,
        dutchInterest: false,
        netFunding: null,
        originationDate: null,
        fundedDate: null,
        loanDocuments: [],
        subjectProperties: [
          {
            _id: "68ed0edd4e79a360968bf77e",
            dealId: null,
            salesforceId: null,
            address: {
              fullAddress: "116 Orange Avenue, Winter Haven, FL 33880",
              streetName: "Orange Avenue",
              streetNumber: "116",
              zip: "33880",
              county: "Polk",
              state: "FL",
              city: "Winter Haven",
              country: "United States",
              latitude: 27.995275,
              longitude: -81.745219,
              addressUnitNumber: null,
              displayAddress: null,
              input_address: null,
              geolocation: null,
              apn: null,
              unit: null,
              id: "_-z6LQRUoLUC68vtOdGAfA-1760366224888",
              countryCode: "US",
              coordinateTuple: [27.995275, -81.745219],
              score: 0.9584931285842283,
              streetAddress: "116 Orange Avenue",
            },
            propertyType: "SFR",
            proposedPropertyType: null,
            last_integration_sync: null,
            propertyRuralIndicator: false,
            asIsValue: 200000,
            arv: null,
            secondaryArv: null,
            appraisalDate: null,
            secondaryAppraisalDate: null,
            purchasePrice: null,
            additionalBasis: null,
            assignmentFees: null,
            sellersConcession: null,
            purchaseDate: null,
            propertyListedForSale: null,
            lastListedForSaleDate: null,
            lastListedForSalePrice: null,
            changeOfUseFlag: null,
            condoConversion: null,
            floodZone: false,
            floodCertDate: null,
            residentialSqFootage: null,
            commercialSqFootage: null,
            afterRenoSqFootage: null,
            annualTaxes: 2700,
            annualInsurance: 1500,
            annualFloodInsurance: null,
            annualHoaFees: null,
            annualPropertyMgmtFees: null,
            annualOtherExpense: null,
            propertyConditionAtOrigination: null,
            propertyStatusAtOrigination: null,
            constructionBudget: null,
            financedBudgetPercent: null,
            budgetIsFinal: null,
            budgetMatchesAppraisal: null,
            finalBudgetUploaded: null,
            finalBudgetFeasible: null,
            scopeOfWork: [],
            units: [],
            subjectPropertyNotes: null,
            costBasis: 0,
            secondaryAsIsVariance: 0,
            secondaryArvVariance: 0,
            unitCount: 0,
            vacantUnitCount: 0,
            residentialUnitCount: 0,
            commercialUnitCount: 0,
            monthlyTaxes: 225,
            monthlyInsurance: 125,
            monthlyFloodInsurance: 0,
            monthlyHoaFees: 0,
            monthlyPropertyMgmtFees: 0,
            monthlyOtherExpense: 0,
            squareFootageChange: 0,
            financedBudget: null,
            feasibility_required: null,
          },
        ],
        borrowers: [
          {
            _id: "68ed0edd4e79a360968bf77f",
            firstName: null,
            lastName: null,
            company: null,
            phoneNumber: null,
            emailAddress: null,
            createDateTime: "2025-10-06T17:51:22.346000",
            role: null,
            signUpDate: "2025-10-06T17:51:22.346000",
            bankDetails: null,
            contactId: null,
            dealId: null,
            dealIds: null,
            salesforceId: null,
            isExperienced: null,
            estimatedFICO: null,
            integration_id: null,
            last_integration_sync: null,
            estimatedNumericFICO: null,
            ficoLow: 0,
            ficoMid: 0,
            ficoMax: 0,
            creditReportDate: null,
            creditAuthDate: null,
            backgroundDate: null,
            otherLiquidity: 0,
            cashLiquidity: 0,
            borrowerSSN: null,
            primaryAddress: null,
            entityPercentOwnership: 0,
            isGuarantor: false,
            isPrimaryContactForLoan: false,
            borrowerIdType: null,
            idExpirationDate: null,
            maritalStatus: null,
            firstTimeHomebuyer: false,
            housing_event_types: null,
            housing_events: null,
            mortgage_lates: null,
            additional_borrower_notes: null,
            time_since_housing_event: null,
            time_since_bankruptcy: null,
            hasExperienceWithIncomeProducingProperties: false,
            hasExperienceWithFixFlips: false,
            hasExperienceWithGroundUpConstruction: false,
            ff_sold: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            ff_retained_as_rental: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            income_producing_properties: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            guc_sold: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            guc_retained_as_rental: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            general_contractor_projects: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            citizenshipStatus: null,
            dateOfBirth: null,
            validatedExperience: null,
            verifiedLiquidity: 0,
            verifiedExperienceTotal: 0,
            borrowerGuidelineChecks: [],
            profileComplete: false,
            totalLiquidity: 0,
            foreignNationalFlag: false,
            email_lower: null,
            email_domain: null,
          },
        ],
        updateHistory: [],
        borrowerEntity: null,
        termMonths: 0,
        interestOnlyMonths: 0,
        expectedClosingDate: "2025-11-14T05:00:00",
        applicationFeeDate: null,
        salesforceIntegration: null,
        integration_id: null,
        last_integration_sync: null,
        investorCounterparty: null,
        referralPartner: null,
        referralSource: null,
        closingScheduled: null,
        closingScheduledDate: null,
        interestRate: 0,
        discountPoints: 0,
        originationPoints: 0,
        floatingRateLoan: null,
        floatingRateLoanBaseRate: null,
        floatingRateLoanFloorRate: null,
        floatingRateLoanCapRate: null,
        floatingRateLoanRateIndex: null,
        floatingRateLoanRateMargin: null,
        closingFees: null,
        refinancingAssetId: null,
        closingAsEntity: null,
        amortizationType: null,
        interestCalcType: "Actual/360",
        outstandingLoanUpb: 0,
        exisitingLender: null,
        vomPaymentHistory: null,
        existingLoanInDefault: false,
        existingLoanDefaultType: null,
        dealDeadReason: null,
        dealDeadNotes: null,
        prepaymentPenaltyMonths: null,
        prepaymentPenaltyStructure: null,
        appraisals: null,
        relatedContacts: null,
        subscribedUsers: null,
        comments: [
          {
            _id: "68ed0f404e79a360968bf78e",
            commentType: null,
            htmlString: "<p>Sent revised loan quote</p>\n",
            postedBy: "shaun@resilender.com",
            commentDateTime: "2025-10-13T14:40:00.651000",
            mentions: [],
            dealId: null,
            associations: {
              loanDocuments: [],
              borrowers: [],
              subjectProperties: [],
              applications: null,
              creditAuthorizations: null,
              conditions: null,
              taskListItems: null,
              managementExceptions: null,
              comments: null,
              tasks: null,
              entities: null,
            },
            comments: null,
            exceptions: null,
            submittedBy: "shaun@resilender.com",
          },
        ],
        creditAuthorizations: null,
        applications: null,
        exceptions: null,
        guidelineConforming: null,
        underwritingCheckList: {
          initialUnderwritingIsCompletedStatus: false,
          appraisalDate: null,
          creditReportDate: null,
          backgroundReportDate: null,
          certificateOfGoodStandingDate: null,
          identificationExpirationDate: null,
          lastBankStatementEndDate: null,
          ofacReportDate: null,
          payoffLetterGoodThroughDate: null,
          rentalLeaseExpirationDate: null,
          docCollectionStatus: null,
          verificationOfMortgageStatus: null,
          appraisalReportStatus: null,
          backgroundReportStatus: null,
          closingPackageStatus: null,
          condoQuestionnaireStatus: null,
          creditAuthStatus: null,
          creditReportStatus: null,
          entityDocsStatus: null,
          enviornmentalReportStatus: null,
          estoppelLetterReportStatus: null,
          experienceDocsStatus: null,
          floodCertificateStatus: null,
          feasibilityReportStatus: null,
          loanApplicationStatus: null,
          hoaDuesStatus: null,
          identificationStatus: null,
          insuranceDocsStatus: null,
          liquidityDocsStatus: null,
          managementAgreementStatus: null,
          managementQuestionnaireStatus: null,
          ofacReportStatus: null,
          payoffLetterStatus: null,
          preliminaryTitleStatus: null,
          preliminaryHudStatus: null,
          proofOfRentStatus: null,
          purchaseContractStatus: null,
          purchaseHudStatus: null,
          rehabBudgetStatus: null,
          rentalLeaseStatus: null,
          secondaryValuationStatus: null,
          vomStatus: null,
        },
        loanLock: null,
        titleReport: null,
        underwritingNotes: null,
        applicationFees: null,
        contactOriginalSource: null,
        sourceCategory: null,
        additionalSourceDetails: null,
        tags: null,
        dscr: null,
        totalInPlaceRents: null,
        totalMarketRents: null,
        createdBy: "shaun@resilender.com",
        totalLoanAmount: 140000,
        totalPurchasePrice: 0,
        totalAsIsValue: 200000,
        totalArv: 0,
        totalCostBasis: 0,
        totalConstructionBudget: 0,
        baseLoanToAsIsValue: 0.7,
        baseLoanToPurchasePrice: 0,
        totalLoanToArv: 0,
        _property_totals: {
          purchasePrice: 0,
          asIsValue: 200000,
          arv: 0,
          secondaryAsIsValue: 0,
          secondaryArv: 0,
          costBasis: 0,
          assignmentFees: 0,
          annualTaxes: 2700,
          annualInsurance: 1500,
          annualFloodInsurance: 0,
          annualHoaFees: 0,
          annualPropertyMgmtFees: 0,
          annualOtherExpense: 0,
          constructionBudget: 0,
        },
        amortizingTermMonths: 0,
        totalSecondaryAsIsValue: 0,
        totalSecondaryArv: 0,
        totalAssignmentFees: 0,
        totalAnnualTaxes: 2700,
        totalAnnualInsurance: 1500,
        totalAnnualFloodInsurance: 0,
        totalAnnualHoaFees: 0,
        totalAnnualPropertyMgmtFees: 0,
        totalAnnualOtherExpense: 0,
        baseLoanToCost: 0,
        foreignNationalIndicator: null,
        firstPaymentDate: "2026-01-01T00:00:00",
        maturityDate: "2025-12-01T00:00:00",
      },
      {
        _id: "68ea96144e79a360968bf157",
        createDateTime: "2025-10-11T17:38:28.441000",
        updateDateTime: "2025-10-11T18:35:46.449000",
        lastViewDateTime: "2025-10-14T16:47:02.519000",
        pipeline: "Underwriting",
        loanNumber: 1217,
        assetId: null,
        loanName: "942 S Silverwood Ln, Nixa, MO 65714 (Wolf Development)",
        isTableFunding: false,
        isBalanceSheetClosing: false,
        loanStatus: "Underwriting",
        milestoneStatusChanges: null,
        loanProductType: "Ground Up Construction",
        loanPurpose: null,
        purchaseTOE: null,
        exitStrategy: null,
        salesperson: null,
        processor: null,
        underwriter: null,
        loanCloser: null,
        permittedUsers: [],
        baseLoanAmount: 0,
        totalHoldback: 0,
        dutchInterest: false,
        netFunding: null,
        originationDate: null,
        fundedDate: null,
        loanDocuments: [],
        subjectProperties: [
          {
            _id: "68ea96144e79a360968bf158",
            dealId: null,
            salesforceId: null,
            address: {
              fullAddress: "South Silverwood Lane, Nixa, MO 65714",
              streetName: "South Silverwood Lane",
              streetNumber: "",
              zip: "65714",
              county: "Christian",
              state: "MO",
              city: "Nixa",
              country: "United States",
              latitude: 37.0273568,
              longitude: -93.3081314,
              addressUnitNumber: null,
              displayAddress: null,
              input_address: null,
              geolocation: null,
              apn: null,
              unit: null,
              id: "cRjUKJfeodZ2gOqeu0U1aQ-1760204294747",
              countryCode: "US",
              coordinateTuple: [37.0273568, -93.3081314],
              score: 0.9110772864980359,
              streetAddress: " South Silverwood Lane",
            },
            propertyType: null,
            proposedPropertyType: null,
            last_integration_sync: null,
            propertyRuralIndicator: false,
            asIsValue: null,
            arv: null,
            secondaryArv: null,
            appraisalDate: null,
            secondaryAppraisalDate: null,
            purchasePrice: null,
            additionalBasis: null,
            assignmentFees: null,
            sellersConcession: null,
            purchaseDate: null,
            propertyListedForSale: null,
            lastListedForSaleDate: null,
            lastListedForSalePrice: null,
            changeOfUseFlag: null,
            condoConversion: null,
            floodZone: null,
            floodCertDate: null,
            residentialSqFootage: null,
            commercialSqFootage: null,
            afterRenoSqFootage: null,
            annualTaxes: null,
            annualInsurance: null,
            annualFloodInsurance: null,
            annualHoaFees: null,
            annualPropertyMgmtFees: null,
            annualOtherExpense: null,
            propertyConditionAtOrigination: null,
            propertyStatusAtOrigination: null,
            constructionBudget: null,
            financedBudgetPercent: null,
            budgetIsFinal: null,
            budgetMatchesAppraisal: null,
            finalBudgetUploaded: null,
            finalBudgetFeasible: null,
            scopeOfWork: [],
            units: [],
            subjectPropertyNotes: null,
            costBasis: 0,
            secondaryAsIsVariance: 0,
            secondaryArvVariance: 0,
            unitCount: 0,
            vacantUnitCount: 0,
            residentialUnitCount: 0,
            commercialUnitCount: 0,
            monthlyTaxes: 0,
            monthlyInsurance: 0,
            monthlyFloodInsurance: 0,
            monthlyHoaFees: 0,
            monthlyPropertyMgmtFees: 0,
            monthlyOtherExpense: 0,
            squareFootageChange: 0,
            financedBudget: null,
            feasibility_required: null,
          },
        ],
        borrowers: [
          {
            _id: "68ea96144e79a360968bf159",
            firstName: null,
            lastName: null,
            company: null,
            phoneNumber: null,
            emailAddress: null,
            createDateTime: "2025-10-06T17:51:22.346000",
            role: null,
            signUpDate: "2025-10-06T17:51:22.346000",
            bankDetails: null,
            contactId: null,
            dealId: null,
            dealIds: null,
            salesforceId: null,
            isExperienced: null,
            estimatedFICO: null,
            integration_id: null,
            last_integration_sync: null,
            estimatedNumericFICO: null,
            ficoLow: 0,
            ficoMid: 0,
            ficoMax: 0,
            creditReportDate: null,
            creditAuthDate: null,
            backgroundDate: null,
            otherLiquidity: 0,
            cashLiquidity: 0,
            borrowerSSN: null,
            primaryAddress: null,
            entityPercentOwnership: 0,
            isGuarantor: false,
            isPrimaryContactForLoan: false,
            borrowerIdType: null,
            idExpirationDate: null,
            maritalStatus: null,
            firstTimeHomebuyer: false,
            housing_event_types: null,
            housing_events: null,
            mortgage_lates: null,
            additional_borrower_notes: null,
            time_since_housing_event: null,
            time_since_bankruptcy: null,
            hasExperienceWithIncomeProducingProperties: false,
            hasExperienceWithFixFlips: false,
            hasExperienceWithGroundUpConstruction: false,
            ff_sold: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            ff_retained_as_rental: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            income_producing_properties: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            guc_sold: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            guc_retained_as_rental: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            general_contractor_projects: {
              less_than_three_years: 0,
              greater_than_three_years: 0,
            },
            citizenshipStatus: null,
            dateOfBirth: null,
            validatedExperience: null,
            verifiedLiquidity: 0,
            verifiedExperienceTotal: 0,
            borrowerGuidelineChecks: [],
            profileComplete: false,
            totalLiquidity: 0,
            foreignNationalFlag: false,
            email_lower: null,
            email_domain: null,
          },
        ],
        updateHistory: [],
        borrowerEntity: null,
        termMonths: 0,
        interestOnlyMonths: 0,
        expectedClosingDate: "2025-11-17T17:51:22.739000",
        applicationFeeDate: null,
        salesforceIntegration: null,
        integration_id: null,
        last_integration_sync: null,
        investorCounterparty: null,
        referralPartner: null,
        referralSource: null,
        closingScheduled: null,
        closingScheduledDate: null,
        interestRate: 0,
        discountPoints: 0,
        originationPoints: 0,
        floatingRateLoan: null,
        floatingRateLoanBaseRate: null,
        floatingRateLoanFloorRate: null,
        floatingRateLoanCapRate: null,
        floatingRateLoanRateIndex: null,
        floatingRateLoanRateMargin: null,
        closingFees: null,
        refinancingAssetId: null,
        closingAsEntity: null,
        amortizationType: null,
        interestCalcType: "Actual/360",
        outstandingLoanUpb: 0,
        exisitingLender: null,
        vomPaymentHistory: null,
        existingLoanInDefault: false,
        existingLoanDefaultType: null,
        dealDeadReason: null,
        dealDeadNotes: null,
        prepaymentPenaltyMonths: null,
        prepaymentPenaltyStructure: null,
        appraisals: null,
        relatedContacts: null,
        subscribedUsers: null,
        comments: null,
        creditAuthorizations: null,
        applications: null,
        exceptions: null,
        guidelineConforming: null,
        underwritingCheckList: {
          initialUnderwritingIsCompletedStatus: false,
          appraisalDate: null,
          creditReportDate: null,
          backgroundReportDate: null,
          certificateOfGoodStandingDate: null,
          identificationExpirationDate: null,
          lastBankStatementEndDate: null,
          ofacReportDate: null,
          payoffLetterGoodThroughDate: null,
          rentalLeaseExpirationDate: null,
          docCollectionStatus: null,
          verificationOfMortgageStatus: null,
          appraisalReportStatus: null,
          backgroundReportStatus: null,
          closingPackageStatus: null,
          condoQuestionnaireStatus: null,
          creditAuthStatus: null,
          creditReportStatus: null,
          entityDocsStatus: null,
          enviornmentalReportStatus: null,
          estoppelLetterReportStatus: null,
          experienceDocsStatus: null,
          floodCertificateStatus: null,
          feasibilityReportStatus: null,
          loanApplicationStatus: null,
          hoaDuesStatus: null,
          identificationStatus: null,
          insuranceDocsStatus: null,
          liquidityDocsStatus: null,
          managementAgreementStatus: null,
          managementQuestionnaireStatus: null,
          ofacReportStatus: null,
          payoffLetterStatus: null,
          preliminaryTitleStatus: null,
          preliminaryHudStatus: null,
          proofOfRentStatus: null,
          purchaseContractStatus: null,
          purchaseHudStatus: null,
          rehabBudgetStatus: null,
          rentalLeaseStatus: null,
          secondaryValuationStatus: null,
          vomStatus: null,
        },
        loanLock: null,
        titleReport: null,
        underwritingNotes: null,
        applicationFees: null,
        contactOriginalSource: null,
        sourceCategory: null,
        additionalSourceDetails: null,
        tags: ["ev26032"],
        dscr: null,
        totalInPlaceRents: null,
        totalMarketRents: null,
        createdBy: "cnguyen@cliffcomortgage.com",
        totalLoanAmount: 0,
        totalPurchasePrice: 0,
        totalAsIsValue: 0,
        totalArv: 0,
        totalCostBasis: 0,
        totalConstructionBudget: 0,
        baseLoanToAsIsValue: 0,
        baseLoanToPurchasePrice: 0,
        totalLoanToArv: 0,
        _property_totals: {
          purchasePrice: 0,
          asIsValue: 0,
          arv: 0,
          secondaryAsIsValue: 0,
          secondaryArv: 0,
          costBasis: 0,
          assignmentFees: 0,
          annualTaxes: 0,
          annualInsurance: 0,
          annualFloodInsurance: 0,
          annualHoaFees: 0,
          annualPropertyMgmtFees: 0,
          annualOtherExpense: 0,
          constructionBudget: 0,
        },
        amortizingTermMonths: 0,
        totalSecondaryAsIsValue: 0,
        totalSecondaryArv: 0,
        totalAssignmentFees: 0,
        totalAnnualTaxes: 0,
        totalAnnualInsurance: 0,
        totalAnnualFloodInsurance: 0,
        totalAnnualHoaFees: 0,
        totalAnnualPropertyMgmtFees: 0,
        totalAnnualOtherExpense: 0,
        baseLoanToCost: 0,
        foreignNationalIndicator: null,
        firstPaymentDate: "2026-01-01T00:00:00",
        maturityDate: "2025-12-01T00:00:00",
      },
    ],
  },
];
